import type { EditorialAnalysis } from '../../types/payload'
import styles from './Section.module.css'

interface Props {
  editorial: EditorialAnalysis
}

export function ResumoEditorial({ editorial }: Props) {
  return (
    <section className={styles.editorialAnalysisCard}>
      <div className={styles.editorialAnalysisHeader}>
        <h2 className={styles.editorialAnalysisTitle}>Análise Editorial da Edição</h2>
        <p className={styles.editorialAnalysisSubtitle}>
          Leitura de dinâmica de preços e eficiência operacional
        </p>
      </div>

      <div className={styles.editorialAnalysisColumns}>
        <div className={styles.editorialAnalysisColumn}>
          <h3 className={styles.editorialAnalysisColumnTitle}>Visão Geral &amp; Variação de Preço</h3>
          <p className={styles.editorialAnalysisText}>{editorial.generalSummary}</p>
          <p className={styles.editorialAnalysisText}>{editorial.priceVariationInsight}</p>
        </div>

        <div className={styles.editorialAnalysisColumn}>
          <h3 className={styles.editorialAnalysisColumnTitle}>Ruptura &amp; Disponibilidade</h3>
          <p className={styles.editorialAnalysisText}>{editorial.ruptureInsight}</p>
        </div>
      </div>
    </section>
  )
}
